import type { ChecklistDto } from "./checklist.dto";
import type { GetChecklistDto } from "./get-checklists.dto";

import { api } from "../core/api";

export async function getUserChecklists(filters?: GetChecklistDto) {
  const init =
    filters &&
    (Object.entries(filters).filter((it) => !!it[1]) as [string, string][]);
  const search = new URLSearchParams(init);
  const { data } = await api.get<GetChecklistsResponse>(
    `/api/v1/users/my_checklists?${search}`
  );
  return data;
}

interface GetChecklistsResponse {
  data: ChecklistDto[];
  meta: { total_items: number; next_page: number | null };
}

export async function getHistoryThemes() {
  const { data } = await api.get<{
    data: Array<HistoryTheme>;
  }>("/api/v1/users/history_themes");
  return data.data;
}

interface HistoryTheme {
  id: string;
  name: string;
  user_tests_count: number;
  banner_url?: string;
}
